function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useEffect, useCallback, useContext } from 'react';
import styled, { withTheme } from 'styled-components';
import Select, { components } from 'react-select';
import PropTypes from 'prop-types';
import { ThemeContext } from 'grommet';
const ReactSelect = styled(Select)`
  .select__menu {
    z-index: 5;
  }
  .select__control {
    background-color: ${({
  backgroundColor
}) => backgroundColor};
    border-width: ${({
  borderWidth
}) => borderWidth};
    border-color: ${({
  borderColor
}) => borderColor || '#cccccc'};
    box-shadow: none;
    outline: none;
    max-height: 100%;
    overflow: auto;
    &:focus,
    &:hover {
      border-width: ${({
  borderWidth
}) => borderWidth};
      border-color: ${({
  borderColor
}) => borderColor || '#cccccc'};
      box-shadow: none;
      outline: none;
    }
  }
  .select__indicators {
    -webkit-align-items: normal;
    -webkit-box-align: normal;
    align-items: normal;
    .select__clear-indicator {
      align-self: flex-start;
    }
  }
  .select__value-container {
    padding: 2px;
    > div:last-child {
      margin: 0;
    }
  }
`;
const StyledSpan = styled.span`
  overflow: hidden;
  white-space: nowrap;
  max-width: 90%;
`;
const SelectWrapper = ({
  name,
  value,
  labelKey,
  valueKey,
  options: defaultOptions,
  size,
  disabled,
  onChange,
  onBlur,
  isSearchable,
  isClearable,
  loading,
  isMulti,
  defaultSelectedOptions,
  theme,
  closeMenuOnSelect,
  isOptionsGrouped,
  components,
  ...rest
}) => {
  const [options, setOptions] = useState(defaultOptions);
  const [mode, setMode] = useState(null);
  useEffect(() => {
    if (typeof defaultOptions[0] === 'object') {
      if (typeof valueKey === 'object' && valueKey.reduce === true) {
        setMode('A');
      } else if (typeof valueKey === 'object' && !valueKey.reduce) {
        setMode('B');
      } else if (typeof valueKey === 'string') {
        setMode('D');
      }
    } else if (typeof defaultOptions[0] === 'string') {
      setMode('C');
    }
  }, [defaultOptions, valueKey]);
  useEffect(() => {
    let arr;
    if (mode === 'C') {
      arr = defaultOptions.map(i => {
        return {
          value: i,
          label: i
        };
      });
    } else {
      arr = defaultOptions;
    }
    setOptions(arr);
  }, [defaultOptions, mode]);
  const setChange = useCallback((option, event) => {
    let arg = mode === 'A' ? {
      value: option && option[valueKey?.key]
    } : mode === 'B' ? {
      value: option
    } : mode === 'C' ? {
      value: option?.value
    } : mode === 'D' ? {
      value: option
    } : null;
    if (isMulti) arg = option;
    if (isMulti && event.action === 'remove-value' && mode === 'A') {
      arg = defaultSelectedOptions.filter(i => i[valueKey.key] !== event.removedValue[valueKey.key]);
    }
    if (isMulti && !arg) arg = [];
    if (!isMulti && !arg) arg = {};
    onChange(arg);
  }, [mode, valueKey, isMulti, onChange, defaultSelectedOptions]);
  const computeDefault = useCallback(() => {
    if (isMulti) return defaultSelectedOptions;
    if (isOptionsGrouped) {
      const arrOptions = options?.map(itm => itm.options).reduce((acc, val) => acc.concat(val), []);
      return arrOptions?.find(i => i?.value === value);
    }
    if (value !== undefined && value !== null && options) {
      if (mode === 'A') {
        return options.find(i => i[valueKey?.key] === value);
      } else if (mode === 'B') {
        return options.find(i => i[valueKey?.key] === value);
      } else if (mode === 'C') {
        return options.find(i => i.value === value);
      } else if (mode === 'D') {
        return options.find(i => i[valueKey] === value);
      }
    }
  }, [defaultSelectedOptions, isMulti, options, value, valueKey, mode, isOptionsGrouped]);
  const getOptionLabel = useCallback(option => {
    if (mode === 'A' || mode === 'B' || mode === 'D') {
      return option[labelKey];
    } else if (mode === 'C') {
      return option.label;
    }
  }, [mode, labelKey]);
  const isOptionSelected = option => {
    if (value) {
      if (mode === 'A') {
        return value === option[valueKey.key] ? true : false;
      } else if (mode === 'B') {
        return value === option[valueKey.key] ? true : false;
      } else if (mode === 'C') {
        return value === option.value ? true : false;
      } else if (mode === 'D') {
        return value[valueKey] === option[valueKey];
      }
    }
  };
  const styles = {
    control: base => ({
      ...base,
      fontSize: 'small'
    }),
    menu: base => ({
      ...base,
      fontSize: 'small',
      background: theme.global.colors['bgColor']
    }),
    option: (provided, state) => ({
      ...provided,
      fontFamily: theme.global.font['family'],
      color: state.isSelected ? '#ffffff' : state.isDisabled ? '#8f96a3' : theme.global.colors['textColor'],
      backgroundColor: state.isSelected ? theme.global.colors['brand'] : state.isFocused ? 'rgba(0, 184, 217, 0.1)' : theme.global.colors['bgColor']
    }),
    singleValue: (base, state) => ({
      ...base,
      color: state.isDisabled ? '#8f96a3' : theme.global.colors['textColor']
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: state.isFocused ? theme.global.colors['brand'] : `${theme.global.colors['brand']}88`
    }),
    menuPortal: base => ({
      ...base,
      zIndex: 9999
    }),
    ...(theme?.selectTheme ?? {})
  };
  return /*#__PURE__*/React.createElement(ReactSelect, _extends({
    className: isMulti ? 'basic-multi-select' : 'basic-single',
    classNamePrefix: "select",
    value: computeDefault(),
    isDisabled: disabled,
    placeholder: "",
    isLoading: loading,
    isClearable: disabled ? false : isClearable,
    isSearchable: isSearchable,
    name: name,
    options: options,
    onChange: setChange,
    onBlur: onBlur,
    getOptionLabel: getOptionLabel,
    isOptionSelected: isOptionSelected,
    styles: styles,
    backgroundColor: theme.global.colors['bgColor'],
    borderColor: theme?.selectTheme?.borderColor,
    key: value,
    isMulti: isMulti,
    closeMenuOnSelect: closeMenuOnSelect,
    menuPlacement: "auto",
    components: {
      SingleValue,
      MultiValue,
      ...components
    },
    menuPortalTarget: document.body
  }, rest));
};
const SingleValue = ({
  ...rest
}) => {
  const theme = useContext(ThemeContext);
  const {
    hideAllFieldTooltip
  } = theme;
  return /*#__PURE__*/React.createElement("span", {
    title: !hideAllFieldTooltip && rest.children
  }, /*#__PURE__*/React.createElement(components.SingleValue, rest));
};
const MultiValue = ({
  ...rest
}) => {
  const theme = useContext(ThemeContext);
  const {
    hideAllFieldTooltip
  } = theme;
  return /*#__PURE__*/React.createElement(StyledSpan, {
    title: !hideAllFieldTooltip && rest.children
  }, /*#__PURE__*/React.createElement(components.MultiValue, rest));
};
SelectWrapper.defaultProps = {
  onBlur: () => {},
  isSearchable: true,
  onChange: () => {},
  disabled: false,
  isClearable: true,
  value: {},
  loading: false,
  isMulti: false,
  closeMenuOnSelect: false,
  isOptionsGrouped: false,
  components: {},
  borderWidth: '0px'
};
SelectWrapper.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  labelKey: PropTypes.string,
  valueKey: PropTypes.any,
  options: PropTypes.array,
  size: PropTypes.any,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  isSearchable: PropTypes.bool,
  isClearable: PropTypes.bool,
  loading: PropTypes.bool,
  isMulti: PropTypes.bool,
  defaultSelectedOptions: PropTypes.any,
  theme: PropTypes.object,
  closeMenuOnSelect: PropTypes.bool,
  isOptionsGrouped: PropTypes.bool,
  components: PropTypes.object,
  borderWidth: PropTypes.string
};
const SelectHoc = withTheme(SelectWrapper);
SelectHoc.displayName = 'Select';
export default SelectHoc;